import React, { useState, useEffect } from 'react';
import { Chart } from 'primereact/chart';
import { DashHeaderIndex } from "@Src/features/Dashboard/Dash-header/Dash-header";
import { DashboardSidebarIndex } from "@Src/features/Dashboard/Sidebar/Index";
import { Dropdown } from 'primereact/dropdown';
import { Skeleton } from 'primereact/skeleton';
import './SkillwiseAnalytics.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { getSkillAnalysis } from './services/skillwise-analytics.service';
import { useAppSelector } from "@Src/app/hooks";
import { getSubjectList } from "@Src/features/UserProfile/Services/UserProfile.sevice";
import { getChapterList, getTopicList } from "@Src/features/TestDetails/services/TestDetails.service";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { AppRouteURL, TestSereisRouteURL } from '@Constants/app-route-url.constant';
import { setSubjectList } from '@Src/app/reducers/header/headerSlice';
import { useAnalyticsAccess } from '@Src/hooks/useAnalyticsAccess';
import { isInstituteStudent } from '@Src/utils/studentTypeUtils';
import { Trans, useTranslation } from 'react-i18next';

export const SkillwiseAnalyticsIndex = () => {
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [analysisData, setAnalysisData] = useState<any>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [skillAnalyticsArray, setSkillAnalyticsArray] = useState<any>([]);
    const { isCheckingAccess, hasAnalyticsAccess } = useAnalyticsAccess();

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const coursePreferences = useAppSelector((state: any) => state.coursePreferences);
    const boardId = coursePreferences?.boardDetails?.[0]?.Id;
    const classId = coursePreferences?.classDetails?.[0]?.Id;

    const [subjects, setSubjects] = useState<any[]>([]);
    const [chapters, setChapters] = useState<any[]>([]);
    const [topics, setTopics] = useState<any[]>([]);

    const [selectedSubject, setSelectedSubject] = useState<any>(null);
    const [selectedChapter, setSelectedChapter] = useState<any>(null);
    const [selectedTopic, setSelectedTopic] = useState<any>(null);
    const [loadingSubjects, setLoadingSubjects] = useState(false);
    const userState = useAppSelector((state: any) => state.login);
    const isInstitute: boolean = isInstituteStudent(userState);

    const location = useLocation();
    const userTestId = location.state?.userTestId;
    const testName = location.state?.testName;

    const { t } = useTranslation("common");
    const analysisName =
        (userTestId && testName)
            ? t("skillwise_analytics_of", { testName })
            : t("skill_analytics_overview");


    const getSkillAnalysisData = async () => {
        setIsLoading(true);
        try {
            const params: any = {};
            if (userTestId) params.userTestId = userTestId;
            if (selectedSubject && !userTestId) {
                const classId = coursePreferences?.classDetails[0]?.Id;
                const boardId = coursePreferences?.boardDetails[0]?.Id;
                params.subjectId = selectedSubject.Id;
                params.classId = classId;
                params.boardId = boardId;
            };
            // if (selectedChapter) params.chapterId = selectedChapter.Id;
            // if (selectedTopic) params.topicId = selectedTopic.Id;

            const response = await getSkillAnalysis(params);
            if (response.ResponseType === "SUCCESS" && response.data.length > 0) {
                setAnalysisData(response.data);
            } else {
                setAnalysisData([]);
            }
        } catch (error) {
            console.log(error);
            setAnalysisData([]);
        } finally {
            setIsLoading(false);
        }
    };

    // const fetchSubjectListLocal = async () => {
    //     if (!boardId || !classId) return;
    //     setLoadingSubjects(true);
    //     try {
    //         const response: APIResponse = await getSubjectList({ boardId, classId });
    //         if (response.ResponseType === APIStatus.SUCCESS) {
    //             setSubjects(response.data || []);
    //             if (response.data.length > 0 && !selectedSubject) {
    //                 setSelectedSubject(response.data[0]);
    //             }
    //         }
    //         setLoadingSubjects(false);
    //     } catch (error) {
    //         console.error('Error fetching subject list:', error);
    //         setLoadingSubjects(false)
    //     }
    // };

    // const fetchChapterListLocal = async (subjectId: number) => {
    //     try {
    //         const params = { boardId, classId, subjectId: subjectId.toString() };
    //         const response: APIResponse = await getChapterList(params);
    //         if (response.ResponseType === APIStatus.SUCCESS) {
    //             setChapters(response.data || []);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching chapter list:', error);
    //     }
    // };

    // const fetchTopicListLocal = async (chapterId: number) => {
    //     try {
    //         const params = { chapterId: chapterId.toString() };
    //         const response: APIResponse = await getTopicList(params);
    //         if (response.ResponseType === APIStatus.SUCCESS) {
    //             setTopics(response.data || []);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching topic list:', error);
    //     }
    // };

    useEffect(() => {
        // fetchSubjectListLocal();
        const subjectList = coursePreferences?.subjectDetails ? coursePreferences.subjectDetails.map((s: any) => ({ Id: s.Id, Name: s.Name })) : []
        setSubjects(subjectList);
        if (subjectList.length > 0) {
            setSelectedSubject(subjectList[0])
        }
    }, [boardId, classId, coursePreferences]);

    const onSubjectChange = (e: any) => {
        const val = e.value;
        setSelectedSubject(val);
        setSelectedChapter(null);
        setSelectedTopic(null);
        setChapters([]);
        setTopics([]);
        // if (val) fetchChapterListLocal(val.Id);
    };

    // const onChapterChange = (e: any) => {
    //     const val = e.value;
    //     setSelectedChapter(val);
    //     setSelectedTopic(null);
    //     setTopics([]);
    //     if (val) fetchTopicListLocal(val.Id);
    // };

    // const onTopicChange = (e: any) => {
    //     setSelectedTopic(e.value);
    // };

    // useEffect(() => {
    //     if (userTestId || selectedSubject || selectedChapter || selectedTopic) {
    //         getSkillAnalysisData();

    //     }
    // }, [userTestId, selectedSubject, selectedChapter, selectedTopic]);

    useEffect(() => {
        if (selectedSubject) {
            getSkillAnalysisData();

        }
    }, [userTestId, selectedSubject]);

    const getPerformanceTier = (accuracy: number) => {
        if (accuracy < 30) return 'critical';
        if (30 <= accuracy && accuracy < 50) return 'improving';
        if (50 <= accuracy && accuracy <= 75) return 'developing';
        if (accuracy > 75) return 'mastery';
    };
    const getButtonText = (tier: string) => {
        switch (tier) {
            case 'critical':
                return 'Fix Now';
            case 'improving':
                return 'Practice More';
            case 'developing':
                return 'Improve Accuracy';
            case 'mastery':
                return 'Master This';
            default:
                return 'Fix Now';
        }
    }
    useEffect(() => {

        const topicIds = Array.from(new Set(analysisData.map((item: any) => item.TopicId)));

        const relatedSkillArrays = topicIds.map((topicId: any) => {
            const findData = analysisData.filter((item: any) => item.TopicId === topicId);
            return {
                topicId: topicId,
                topicName: findData[0].TopicName,
                subjectId: findData[0].SubjectId,
                subjectName: findData[0].SubjectName,
                chapterId: findData[0].ChapterId,
                chapterName: findData[0].ChapterName,
                skills: findData.map((item: any) => ({ skillName: item.SkillName, weightedAccuracy: item.WeightedAccuracy })),
                skillIds: findData.map((item: any) => item.SkillId),
                avgWeightedAccuracy: findData.reduce((sum: any, item: any) => sum + Number(item.WeightedAccuracy), 0) / findData.length,
                tier: getPerformanceTier(findData.reduce((sum: any, item: any) => sum + Number(item.WeightedAccuracy), 0) / findData.length)
            }

        });

        setSkillAnalyticsArray(relatedSkillArrays);



    }, [analysisData]);


    useEffect(() => {

    }, [])

    return (
        <>

            <div className="dashboard-container">

                <div className="dashboard-content-page" onClick={() => isSidebarOpen && setIsSidebarOpen(false)}>
                    <div className="skill-analytics-wrapper">
                        <div className="analytics-content-inner">
                            <button className="back-btn" onClick={() => window.history.back()}>
                                <i className="pi pi-chevron-left" /> Back
                            </button>



                            <div className="chart-section-card py-2">

                                <>
                                    <div className='mb-3'>
                                        {(isLoading && loadingSubjects) ? (
                                            <>
                                                <Skeleton width="15rem" height="2rem" className="mb-2" />
                                                <Skeleton width="20rem" height="1.5rem" />
                                            </>
                                        ) :
                                            <>
                                                <h2 className="section-title">{(userTestId && testName) ? t("skillwise_analytics_of", { testName }) : t("skill_analytics_overview")}</h2>
                                                <h3 className="section-subtitle tw-font-semibold mb-3">{t("discover_your_strengths")}</h3>
                                            </>
                                        }
                                    </div>

                                    <div className='lg:tw-flex tw-justify-between tw-items-center'>
                                        <div className="performance-legend md:tw-flex gap-3 mt-1">

                                            {
                                                isCheckingAccess ?
                                                    <>
                                                        <Skeleton width="12rem" height="3.5rem" borderRadius="0.75rem" />
                                                        <Skeleton width="12rem" height="3.5rem" borderRadius="0.75rem" />
                                                        <Skeleton width="12rem" height="3.5rem" borderRadius="0.75rem" />
                                                    </>
                                                    :
                                                    hasAnalyticsAccess &&
                                                    <>
                                                        {(isLoading && loadingSubjects) ? (
                                                            <>
                                                                <Skeleton width="12rem" height="3.5rem" borderRadius="0.75rem" />
                                                                <Skeleton width="12rem" height="3.5rem" borderRadius="0.75rem" />
                                                                <Skeleton width="12rem" height="3.5rem" borderRadius="0.75rem" />
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className="legend-item tw-flex tw-flex-col tw-bg-red-100 tw-px-4 tw-py-2 tw-rounded-lg my-2 md:my-0">
                                                                    <span className='tw-font-semibold'><span className="dot dot-poor"></span>{t("need_more_practice")}</span>
                                                                    <small className='ml-3 tw-font-semibold'>{`${t("accuracy")} < 30%`}</small>
                                                                </div>
                                                                <div className="legend-item tw-flex tw-flex-col tw-bg-orange-100 tw-px-4 tw-py-2 tw-rounded-lg my-2 md:my-0">
                                                                    <span className='tw-font-semibold'><span className="dot dot-improving"></span> {t("improving")}</span>
                                                                    <small className='ml-3 tw-font-semibold'>{`${t("accuracy")} 30% - < 50%`}</small>
                                                                </div>
                                                                <div className="legend-item tw-flex tw-flex-col tw-bg-yellow-100 tw-px-4 tw-py-2 tw-rounded-lg my-2 md:my-0">
                                                                    <span className='tw-font-semibold'><span className="dot dot-medium"></span> {t("developing")}</span>
                                                                    <small className='ml-3 tw-font-semibold'>{`${t("accuracy")} 50% - < = 75%`}</small>
                                                                </div>

                                                                <div className="legend-item tw-flex tw-flex-col tw-bg-green-100 tw-px-4 tw-py-2 tw-rounded-lg my-2 mb-3 md:my-0">
                                                                    <span className='tw-font-semibold'><span className="dot dot-good"></span> {t("mastery")}</span>
                                                                    <small className='ml-3 tw-font-semibold'>{`${t("accuracy")} > 75%`}</small>
                                                                </div>
                                                            </>
                                                        )}
                                                    </>
                                            }

                                        </div>
                                        {isCheckingAccess ? (
                                            <div className='tw-flex tw-items-center tw-gap-3 mt-4 lg:mt-0 ml-auto'>
                                                <Skeleton width="8rem" height="1.2rem" />
                                                <Skeleton width="180px" height="42px" borderRadius="0.75rem" />
                                            </div>
                                        ) :
                                            hasAnalyticsAccess &&
                                            <>
                                                {
                                                    !userTestId &&
                                                    <div className='tw-flex tw-items-center tw-gap-3 mt-4 lg:mt-0 ml-auto'>
                                                        {loadingSubjects ? (
                                                            <div className="tw-flex tw-items-center tw-gap-3">
                                                                <Skeleton width="8rem" height="1.2rem" />
                                                                <Skeleton width="180px" height="42px" borderRadius="0.75rem" />
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <span className='tw-font-semibold'>{t("search_by_subject")}</span>
                                                                <Dropdown
                                                                    value={selectedSubject}
                                                                    options={subjects}
                                                                    onChange={onSubjectChange}
                                                                    optionLabel="Name"
                                                                    placeholder="Select Subject"
                                                                    className="analytics-filter-dropdown"
                                                                    appendTo="self"
                                                                />
                                                            </>
                                                        )}
                                                    </div>
                                                }
                                            </>
                                        }
                                    </div>
                                </>


                                <div className="chart-display-area">
                                    <div className="chart-container">
                                        {
                                            isCheckingAccess ?
                                                <div className="tw-flex tw-flex-col tw-h-[350px] tw-w-full tw-p-4">
                                                    <div className="tw-flex tw-items-end tw-justify-around tw-h-[300px] tw-w-full tw-gap-4 mb-4">
                                                        <Skeleton width="15%" height="40%" borderRadius="10px" />
                                                        <Skeleton width="15%" height="80%" borderRadius="10px" />
                                                        <Skeleton width="15%" height="60%" borderRadius="10px" />
                                                        <Skeleton width="15%" height="30%" borderRadius="10px" />
                                                        <Skeleton width="15%" height="90%" borderRadius="10px" />
                                                    </div>
                                                    <div className="tw-flex tw-justify-around tw-w-full">
                                                        <Skeleton width="12%" height="15px" />
                                                        <Skeleton width="12%" height="15px" />
                                                        <Skeleton width="12%" height="15px" />
                                                        <Skeleton width="12%" height="15px" />
                                                        <Skeleton width="12%" height="15px" />
                                                    </div>
                                                </div>
                                                :
                                                hasAnalyticsAccess ?
                                                    <>
                                                        {/* <div className="relative h-full"> */}
                                                        {isLoading ? (
                                                            <div className="tw-flex tw-flex-col tw-h-[350px] tw-w-full tw-p-4">
                                                                <div className="tw-flex tw-items-end tw-justify-around tw-h-[300px] tw-w-full tw-gap-4 mb-4">
                                                                    <Skeleton width="15%" height="40%" borderRadius="10px" />
                                                                    <Skeleton width="15%" height="80%" borderRadius="10px" />
                                                                    <Skeleton width="15%" height="60%" borderRadius="10px" />
                                                                    <Skeleton width="15%" height="30%" borderRadius="10px" />
                                                                    <Skeleton width="15%" height="90%" borderRadius="10px" />
                                                                </div>
                                                                <div className="tw-flex tw-justify-around tw-w-full">
                                                                    <Skeleton width="12%" height="15px" />
                                                                    <Skeleton width="12%" height="15px" />
                                                                    <Skeleton width="12%" height="15px" />
                                                                    <Skeleton width="12%" height="15px" />
                                                                    <Skeleton width="12%" height="15px" />
                                                                </div>
                                                            </div>
                                                        ) : analysisData.length > 0 ? (
                                                            <>

                                                                {
                                                                    skillAnalyticsArray.map((skill: any, index: any) => {
                                                                        const wrapLabel = (label: string, maxLength: number = 18) => {
                                                                            const parts = label.split(':');
                                                                            const result: string[] = [];
                                                                            parts.forEach((part, i) => {
                                                                                const text = part.trim() + (i < parts.length - 1 ? ' :' : '');
                                                                                if (text.length > maxLength) {
                                                                                    const words = text.split(' ');
                                                                                    let line = '';
                                                                                    words.forEach(word => {
                                                                                        if ((line + word).length > maxLength) {
                                                                                            if (line) result.push(line.trim());
                                                                                            line = word + ' ';
                                                                                        } else {
                                                                                            line += word + ' ';
                                                                                        }
                                                                                    });
                                                                                    if (line) result.push(line.trim());
                                                                                } else {
                                                                                    result.push(text);
                                                                                }
                                                                            });
                                                                            return result;
                                                                        };

                                                                        const data = {
                                                                            labels: skill.skills.map((s: any) => wrapLabel(s.skillName)),
                                                                            datasets: [
                                                                                {
                                                                                    data: skill.skills.map((s: any) => s.weightedAccuracy),
                                                                                    backgroundColor: skill.skills.map((s: any) => s.weightedAccuracy > 75 ? '#25c16f' : s.weightedAccuracy >= 50 ? '#f5de0b' : s.weightedAccuracy > 30 ? '#d57b0c' : '#d82813'),
                                                                                    borderRadius: 10,
                                                                                    barPercentage: 0.4,
                                                                                    barThickness: 50,
                                                                                    categoryPercentage: 0.6,
                                                                                }
                                                                            ]
                                                                        };
                                                                        const options = {
                                                                            maintainAspectRatio: false,
                                                                            responsive: true,
                                                                            plugins: {
                                                                                legend: {
                                                                                    display: false
                                                                                },
                                                                                tooltip: {
                                                                                    enabled: true,
                                                                                    callbacks: {
                                                                                        label: (context: any) => `${context.raw}%`
                                                                                    }
                                                                                }
                                                                            },
                                                                            scales: {
                                                                                x: {
                                                                                    grid: {
                                                                                        display: false,
                                                                                        drawBorder: false
                                                                                    },
                                                                                    ticks: {
                                                                                        color: '#667085',
                                                                                        maxRotation: 0,
                                                                                        minRotation: 0,
                                                                                        autoSkip: false,
                                                                                        font: {
                                                                                            family: 'Poppins',
                                                                                            size: 11,
                                                                                            weight: 600
                                                                                        },
                                                                                        padding: 10
                                                                                    }
                                                                                },
                                                                                y: {
                                                                                    beginAtZero: true,
                                                                                    max: 100,
                                                                                    grid: {
                                                                                        display: false,
                                                                                        drawBorder: false
                                                                                    },
                                                                                    ticks: {
                                                                                        display: false
                                                                                    }
                                                                                }
                                                                            }
                                                                        };

                                                                        return (
                                                                            <div className='chart-sections' key={index}>
                                                                                <div className='topic-header tw-flex tw-justify-between tw-items-start tw-flex-wrap tw-gap-2 '>
                                                                                    <span>{t("topic")}: {skill.topicName}</span>
                                                                                    <div className='tw-ms-auto tw-gap-2 tw-flex tw-flex-wrap'>
                                                                                        <button className={`ia-btn ia-btn-primary py-2 px-3`} onClick={() => {
                                                                                            const board = coursePreferences?.boardDetails?.[0];
                                                                                            const classDetail = coursePreferences?.classDetails?.[0];

                                                                                            const subName = skill.subjectName || selectedSubject?.Name || (subjects.find((s: any) => s.Id === skill.subjectId)?.Name);
                                                                                            navigate(`${TestSereisRouteURL.TEST_SERIES}`, {
                                                                                                state: {
                                                                                                    boardId: board?.Id,
                                                                                                    boardName: board?.Name,
                                                                                                    classId: classDetail?.Id,
                                                                                                    className: classDetail?.Name,
                                                                                                    subjectId: skill.subjectId,
                                                                                                    subjectName: subName,
                                                                                                    chapterId: skill.chapterId,
                                                                                                    chapterName: skill.chapterName,
                                                                                                    topicId: skill.topicId,
                                                                                                    topicName: skill.topicName,
                                                                                                    topicPriority: 1,
                                                                                                    skillId: skill.skillIds,
                                                                                                    difficultyBasedAccuracy: String(skill.avgWeightedAccuracy)
                                                                                                }
                                                                                            })
                                                                                        }} >
                                                                                            {getButtonText(skill.tier)}
                                                                                        </button>
                                                                                        <button className={`ia-btn ia-btn-outline-primary tw-shadow-lg`} onClick={() => {
                                                                                            const board = coursePreferences?.boardDetails?.[0];
                                                                                            const classDetail = coursePreferences?.classDetails?.[0];
                                                                                            const subName = skill.subjectName || selectedSubject?.Name || (subjects.find((s: any) => s.Id === skill.subjectId)?.Name);
                                                                                            navigate(`${AppRouteURL.DASHBOARD}${AppRouteURL.MIND_MAP}`, {
                                                                                                state: {
                                                                                                    boardId: board?.Id,
                                                                                                    boardName: board?.Name,
                                                                                                    classId: classDetail?.Id,
                                                                                                    className: classDetail?.Name,
                                                                                                    subjectId: skill.subjectId,
                                                                                                    subjectName: subName,
                                                                                                    chapterId: skill.chapterId,
                                                                                                    chapterName: skill.chapterName,
                                                                                                    topicId: skill.topicId,
                                                                                                    topicName: skill.topicName,
                                                                                                    // topicPriority: 1,
                                                                                                    returnFromResulPage: 1,

                                                                                                }
                                                                                            })
                                                                                        }}>
                                                                                            Quick Revise
                                                                                        </button>
                                                                                    </div>

                                                                                    {/* <button className={`ia-btn ia-btn-primary py-2 px-4`} onClick={() => {
                                                                                        const board = coursePreferences?.boardDetails?.[0];
                                                                                        const classDetail = coursePreferences?.classDetails?.[0];
                                                                                        const subName = skill.subjectName || selectedSubject?.Name || (subjects.find((s: any) => s.Id === skill.subjectId)?.Name);

                                                                                        navigate(`${TestSereisRouteURL.TEST_SERIES}`, {
                                                                                            state: {
                                                                                                boardId: board?.Id,
                                                                                                boardName: board?.Name,
                                                                                                classId: classDetail?.Id,
                                                                                                className: classDetail?.Name,
                                                                                                subjectId: skill.subjectId,
                                                                                                subjectName: subName,
                                                                                                chapterId: skill.chapterId,
                                                                                                chapterName: skill.chapterName,
                                                                                                topicId: skill.topicId,
                                                                                                topicName: skill.topicName,
                                                                                                topicPriority: 1
                                                                                            }
                                                                                        })
                                                                                    }} >
                                                                                        Learn
                                                                                    </button> */}
                                                                                </div>
                                                                                <Chart type="bar" data={data} options={options} style={{ height: '350px' }} />
                                                                                <div className="percent-overlays">
                                                                                    {data.datasets && data.datasets[0].data.map((val: any, idx: number) => {
                                                                                        return (
                                                                                            <div className='tw-flex flex-column tw-justify-center tw-align-center ml-3'>
                                                                                                <div key={idx} className="percent-val">
                                                                                                    {Number(val).toFixed(2)}%
                                                                                                </div>
                                                                                                {/* <button className={`ia-btn ia-btn-primary py-2 px-4`} onClick={() => {
                                                                                    const board = coursePreferences?.boardDetails?.[0];
                                                                                    const classDetail = coursePreferences?.classDetails?.[0];
                                                                                    const subName = skill.subjectName || selectedSubject?.Name || (subjects.find((s: any) => s.Id === skill.subjectId)?.Name);

                                                                                    navigate(`${TestSereisRouteURL.TEST_SERIES}`, {
                                                                                        state: {
                                                                                            boardId: board?.Id,
                                                                                            boardName: board?.Name,
                                                                                            classId: classDetail?.Id,
                                                                                            className: classDetail?.Name,
                                                                                            subjectId: skill.subjectId,
                                                                                            subjectName: subName,
                                                                                            chapterId: skill.chapterId,
                                                                                            chapterName: skill.chapterName,
                                                                                            topicId: skill.topicId,
                                                                                            topicName: skill.topicName,
                                                                                            topicPriority: 1
                                                                                        }
                                                                                    })
                                                                                }} >
                                                                                    Learn
                                                                                </button> */}
                                                                                            </div>

                                                                                        );
                                                                                    })}
                                                                                </div>

                                                                            </div>
                                                                        )
                                                                    })
                                                                }

                                                            </>
                                                        ) : (
                                                            <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-[350px] tw-w-full tw-bg-gray-50 tw-rounded-xl">

                                                                {/* {
                                                                    (userTestId && testName) ? <div className="tw-text-xl tw-text-gray-700 mb-2"> No data available for <b><span className="tw-text-purple-700">Skillwise Analysis</span></b> of {testName} </div> : <div className="tw-text-xl  tw-text-gray-700 mb-2"> No data available for Overall <b><span className="tw-text-purple-700">Skillwise Analysis</span></b></div>
                                                                } */}
                                                                <Trans
                                                                    i18nKey="no_skill_analysis_data_found"
                                                                    values={{ analysisName }}
                                                                    components={{
                                                                        normaltext: (
                                                                            <span className="tw-flex tw-text-gray-700 gap-1" />
                                                                        ),
                                                                        highlight: (
                                                                            <b className="tw-text-purple-700" />
                                                                        ),
                                                                    }}
                                                                />

                                                            </div>
                                                        )}
                                                        {/* </div> */}
                                                    </>
                                                    :
                                                    <>
                                                        <div className="tw-p-10 tw-text-center tw-text-lg tw-font-medium tw-text-gray-600">
                                                            {isInstitute ? (
                                                                <Trans
                                                                    i18nKey="no_permission_review_institute"
                                                                    values={{ analysisName }}
                                                                    components={{
                                                                        highlight: (
                                                                            <b className="tw-text-purple-700" />
                                                                        ),
                                                                    }}
                                                                />
                                                            ) : (
                                                                <Trans
                                                                    i18nKey="no_permission_review_student"
                                                                    values={{ analysisName }}
                                                                    components={{
                                                                        highlight: (
                                                                            <b className="tw-text-purple-700" />
                                                                        ),
                                                                    }}
                                                                />
                                                            )}
                                                        </div>
                                                    </>

                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {isSidebarOpen && (
                    <div className="sidebar-backdrop" onClick={() => setIsSidebarOpen(false)} />
                )}
            </div>
        </>
    );
};
